import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import axios from 'axios'
import { fetchProducts } from './fetchProducts'
import { getUrlWithVersion } from '../../../api/api'

export const deleteProducts = createAsyncThunk<
    void,
    { products: string[] },
    ThunkConfig<string>
>('productsSlice/deleteProducts', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { products } = args

    const requests = products.map((guid: string) =>
        api.delete(getUrlWithVersion(`/products/${guid}`))
    )

    try {
        await axios.all(requests)
        throwSuccessMessage(`Success!`)
        dispatch(fetchProducts({ isInitialFetch: false }))
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to delete product')
    }
})
